/* bristm-partner-apps — filter pills + search for the partner app directory
   (loaded only where the section renders). Cards carry data-filters (handles)
   and data-search (lower-case text). Idempotent for theme-editor reloads. */
(function () {
  if (window.BRISTM_PARTNER_APPS) return;
  window.BRISTM_PARTNER_APPS = true;

  function initPartnerApps(root) {
    if (root.dataset.bBound) return;
    root.dataset.bBound = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-b-papps-card]'));
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-b-papps-filter]'));
    var form = root.querySelector('[data-b-papps-search]');
    var input = root.querySelector('[data-b-papps-query]');
    var count = root.querySelector('[data-b-papps-count]');
    var empty = root.querySelector('[data-b-papps-empty]');
    var template = root.getAttribute('data-count-template') || '';
    var allLabel = root.getAttribute('data-all-label') || '';

    var activeFilter = '';
    var activeLabel = allLabel;
    var query = '';

    function apply() {
      var words = query.toLowerCase().split(/\s+/).filter(Boolean);
      var shown = 0;

      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-filters') || '').split(' ');
        var text = card.getAttribute('data-search') || '';
        var okFilter = !activeFilter || tags.indexOf(activeFilter) !== -1;
        var okQuery = words.every(function (w) { return text.indexOf(w) !== -1; });
        var visible = okFilter && okQuery;
        card.hidden = !visible;
        if (visible) {
          shown += 1;
          card.classList.add('is-revealed');
        }
      });

      if (count && template) {
        count.textContent = template.replace('[count]', String(shown)).replace('[filter]', activeLabel);
      }
      if (empty) empty.hidden = shown !== 0;
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        activeFilter = pill.getAttribute('data-b-papps-filter') || '';
        activeLabel = pill.textContent.trim();
        pills.forEach(function (p) {
          var on = p === pill;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      });
    });

    if (form && input) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        query = input.value;
        apply();
      });
      input.addEventListener('input', function () {
        query = input.value;
        apply();
      });
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-b-partner-apps]').forEach(initPartnerApps);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
